import { render, staticRenderFns } from "./changeCollectDialog.vue?vue&type=template&id=13e42ce8&scoped=true"
import script from "./changeCollectDialog.vue?vue&type=script&lang=js"
export * from "./changeCollectDialog.vue?vue&type=script&lang=js"
import style0 from "./changeCollectDialog.vue?vue&type=style&index=0&id=13e42ce8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e42ce8",
  null
  
)

export default component.exports